import React from 'react'
import HintPopover from "../../../core/gd-ui/hint-popover/hint-popover"

type Props = {
    name                : string
    icon                : string

    upgradeRequired?    : any // UPGRADE_PRO | UPGRADE_BUSINESS | false

    dndPreview?         : boolean
    dndIsDragged?       : boolean

    style?              : any
    children?           : any

    onClick?            : {(e:any):void}
}

export default class NavigationMenuItemFoldable extends React.Component<Props,any> {

    constructor(props:Props) {
        super(props)

        this.state = {
            isExpanded: false
        }
    }

    onClick = (e:any) => {
        e.stopPropagation()

        if (this.props.upgradeRequired) {
            gd.modals.other.upgrade(this.props.upgradeRequired)
        } else {
            this.setState({
                isExpanded: !this.state.isExpanded
            })
        }
    }

    render() {
        const classes = Classes('item is-foldable',{
            'dnd-preview'   : this.props.dndPreview,
            'dnd-is-dragged': this.props.dndIsDragged,
        })

        const arrowClasses = Classes("arrow", {
            "closed"    : !this.state.isExpanded,
            "open"      : this.state.isExpanded,
        })


        // style is required for ReorderList (pointer-events: none)
        return (
            <React.Fragment>
                <div className={classes} style={this.props.style} onClick={this.onClick}>
                    <div className="row">
                        <div className={arrowClasses}/>
                        <div className={Classes('icon', this.props.icon)}/>
                        <div className="name">{this.props.name}</div>
                    </div>

                    {this.state.useHint && <HintPopover parent={this} hint={this.props.name} multiline={true}/>}
                </div>

                {this.state.isExpanded && this.props.children}
            </React.Fragment>
        )
    }

}

